// extracted by mini-css-extract-plugin
export default {"tooltip":"BranchTooltip_tooltip__b3U5H"};